import { Injectable, Signal, Type, inject } from '@angular/core';
import { Router } from '@angular/router';
import { EnumerationTypeDto } from '@digiwall/core/proxy';
import {
  PlanningDataSource,
  PlanningItemDto,
  ServiceWorkOrderPlanningService,
} from '@digiwall/goliath-documents/proxy';
import { GoliathDocumentsEnumerationTypeStore } from '../../../enumeration-types/enumeration-type.store';
import { BasePlanningAdapter } from '../base-planning.adapter';
import { PlanningDataSourceAdapter } from '../planning-adapter';
import { ServiceWorkOrderBoardFilterComponent } from './service-work-order-board-filter.component';
import { ServiceWorkOrderPlanningCardComponent } from './service-work-order-planning-card.component';
import {
  SERVICE_WORK_ORDER_CARD_FIELDS,
  ServiceWorkOrderPlanningItemFieldsDto,
} from './service-work-order-planning-item-fields';
import { PlanningCardFieldDescriptor } from '../planning-card-field';

/** Planning adapter for ServiceWorkOrder documents. */
@Injectable({ providedIn: 'root' })
export class ServiceWorkOrderPlanningAdapter
  extends BasePlanningAdapter
  implements PlanningDataSourceAdapter
{
  private readonly router = inject(Router);
  private readonly store = inject(GoliathDocumentsEnumerationTypeStore);

  readonly dataSource = PlanningDataSource.ServiceWorkOrder;
  readonly cardComponent: Type<unknown> = ServiceWorkOrderPlanningCardComponent;
  readonly boardFilterComponent: Type<unknown> = ServiceWorkOrderBoardFilterComponent;
  readonly statusEnumeration: Signal<EnumerationTypeDto[]> = this.store.workOrderStatus;
  readonly cardFields: PlanningCardFieldDescriptor[] = SERVICE_WORK_ORDER_CARD_FIELDS;

  constructor() {
    super(inject(ServiceWorkOrderPlanningService));
  }

  searchText(dto: PlanningItemDto): string {
    const fields = (dto.displayFields ?? {}) as ServiceWorkOrderPlanningItemFieldsDto;
    return [
      fields.displayNumber,
      fields.customer,
      fields.responsible,
      fields.article,
      fields.articleCode,
      fields.articleSerial,
    ]
      .filter(Boolean)
      .join(' ');
  }

  openItem(dto: PlanningItemDto): void {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/', 'service-work-order', 'service-work-orders', dto.id]),
    );
    window.open(url, '_blank');
  }
}
